import { GlobalAxios } from "../axios/axios-config";

export interface IReprocessNonLabWorklistResult {
  identifier: number;
  reprocessed: boolean;
  newStatus?: string | null;
  message?: string | null;
}

const REPROCESS_EXAM_SEND_NON_LAB_WORKLIST_Z_ROUTE =
  process.env.REACT_APP_EXTERNAL +
  "/api/v1/ExamSendNonLabWorklistZ/ReprocessExamSendNonLabWorklistZ";

const REPROCESS_RES_SEND_NON_LAB_WORKLIST_Z_ROUTE =
  process.env.REACT_APP_EXTERNAL +
  "/api/v1/ResSendNonLabWorklistZ/ReprocessResSendNonLabWorklistZ";

const REPROCESS_EXAM_SEND_NON_LAB_WORKLIST_Y_SUSPENSION_ROUTE =
  process.env.REACT_APP_EXTERNAL +
  "/api/v1/ExamSendNonLabWorklistY/ReprocessExamSendNonLabWorklistYSuspension";

export const reprocessExamSendNonLabWorklistYSuspension = (
  identifiers: number[],
) => {
  return GlobalAxios.put<IReprocessNonLabWorklistResult[]>(
    REPROCESS_EXAM_SEND_NON_LAB_WORKLIST_Y_SUSPENSION_ROUTE,
    { identifiers },
  );
};

export const reprocessExamSendNonLabWorklistZ =(identifiers: number[]) => {
  return GlobalAxios.put<IReprocessNonLabWorklistResult[]>(
    REPROCESS_EXAM_SEND_NON_LAB_WORKLIST_Z_ROUTE,
    { identifiers },
  );
};

export const reprocessResSendNonLabWorklistZ = (identifiers: number[]) => {
  return GlobalAxios.put<IReprocessNonLabWorklistResult[]>(
    REPROCESS_RES_SEND_NON_LAB_WORKLIST_Z_ROUTE,
    { identifiers },
  );
};
